/**
 * Central helper for opening exclusive customer service (kefu_contact).
 */
export function getKefuContact(baseInfo) {
  const info = baseInfo || {};
  const contact = info.kefu_contact || {};
  const url = contact.url || info.kefu || "";
  return {
    mode: contact.mode || "contact_only",
    title: contact.title || "",
    action_text: contact.action_text || "",
    enabled: contact.enabled == null ? 1 : Number(contact.enabled),
    url,
    name: contact.name || "",
  };
}

export function openKefuContact(vm, options = {}) {
  const store = vm && vm.$store;
  const baseInfo = (store && store.getters && store.getters.getBaseInfo) || {};
  const contact = getKefuContact(baseInfo);
  const url = options.url || contact.url;

  if (url) {
    if (options.newTab) {
      window.open(url, "_blank");
    } else {
      window.location.href = url;
    }
    return true;
  }

  if (vm && vm.$router && !options.skipFallbackRoute) {
    vm.$router.push(options.fallbackPath || "/ServiceOnline");
    return true;
  }

  return false;
}

export function resolveLanguageOptions(baseInfo, fallbackOptions) {
  const allowed = fallbackOptions || [];
  const list = (baseInfo && Array.isArray(baseInfo.lang_list) && baseInfo.lang_list) || [];
  if (!list.length) {
    return allowed;
  }

  const byCode = {};
  allowed.forEach((item) => {
    byCode[item.code] = item;
    byCode[item.appLang] = item;
  });

  // Only keep languages explicitly supported by the frontend allow-list
  const mapped = list
    .map((item) => {
      const code = item.code || item.lang || item.value;
      const known = byCode[code];
      if (!known) {
        return null;
      }
      return {
        ...known,
        fullLabel: item.name || known.fullLabel,
        label: known.label,
      };
    })
    .filter(Boolean);

  const present = new Set(mapped.map((item) => item.code));
  allowed.forEach((item) => {
    if (!present.has(item.code)) {
      mapped.push(item);
    }
  });

  return mapped.length ? mapped : allowed;
}
